import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type AddProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function AddIcon({
  className,
  pathClassName = "stroke-textPrimary",
  ...props
}: AddProps) {
  return (
     <Svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M9.937 4.582v12.26M16.066 10.71H3.806"
        stroke="#1A202C"
        strokeWidth={1.40624}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default AddIcon;
